import React, { useEffect, useRef } from 'react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import { Product_Page_Settings } from '../../CustomElements/elementTypes'

const ProductWalleyDialog = ({ selectedVariant }) => {
   // useRef to maintain a reference to the script element across renders
   const scriptRef = useRef(null)

   const [getSetting, loading] = useSiteSettingsQuery()

   // Determine if the Walley payment widget should be hidden based on site settings
   const hideWalley = getSetting(null, Product_Page_Settings)?.properties?.find(
      s => s.name === 'hideWalley'
   )?.value?.bool

   // Extract the price from the selected variant to use in the script
   const price = selectedVariant?.currentPrice

   useEffect(() => {
      // Cleanup function to remove the script and any iframes from the DOM
      const cleanup = () => {
         const existingFrames = document.getElementsByClassName(
            'collector-checkout-iframe'
         )
         Array.from(existingFrames).forEach(frame => frame.remove())

         // Check if a script is currently referenced and remove it if present
         if (scriptRef.current) {
            scriptRef.current.remove()
            scriptRef.current = null // Clear the reference after removal
         }
      }

      // Execute cleanup to ensure no residues from previous renders affect the current render
      cleanup()

      // Check if conditions are met to avoid initializing the script unnecessarily
      if (!price || hideWalley || loading) {
         // Returning cleanup function here to ensure that it's available for execution
         // when the component unmounts or dependencies change, but not calling it immediately.
         return cleanup
      }

      // Create a script element for the Walley payment widget
      const script = document.createElement('script')
      script.src = 'https://checkout.collector.se/collector-checkout-loader.js'
      script.setAttribute(
         'data-token',
         'widget-SE-0OGtBR3E5dFUrU0YwVEJHZGx4dHVXTnY0ZGt4dERIb083dmwwMGsvMDQ0aEpuMmdvOFZqeXpRTDRrTThWaUNHMDhNNHlkQXFXSFpVZnFSS08rN3YyR0E9PQ'
      )
      script.setAttribute('data-widget', 'part-payment')
      script.setAttribute('data-amount', price * 100) // Convert price to the required format
      script.setAttribute('data-container-id', 'walley-container')

      // Append the script to the DOM and set the ref for possible future removal
      scriptRef.current = script
      document.body.appendChild(script)

      // Return cleanup function to be used for cleaning up the DOM when the component unmounts
      // or if the component's effect is re-run due to changes in its dependencies.
      return cleanup
   }, [price, hideWalley, loading])

   // if (!price || hideWalley || loading) {
   //    return null
   // }

   return (
      <div
         style={{
            marginTop: '1.25rem',
            marginBottom: '1.25rem',
         }}
         id="walley-container"
      />
   )
}

export default ProductWalleyDialog
